import React from 'react'
import { Container, AutocompleteSearch } from 'components/UIElements'
import '../stylesheets/caregiverassignmentlist.scss'
import CaregiversTable from '../../CaregiversPage/components/CaregiversTable'

const getSiteIdValue = list => list.find(el => el.key === 'siteId')?.value

const CaregiverAssignmentList = props => {
  const {
    caregivers,
    filteredItems,
    setFilteredItems,
    updateCaregiverRelation,
    selectedParticipantSubjectId,
    selectedPtp,
  } = props

  const ptpSiteID = getSiteIdValue(selectedPtp)

  const toggleUnCheckAll = () => {
    setFilteredItems([])
  }

  const toggleCaregiver = item => {
    const data = { key: item }
    setFilteredItems(data)
  }

  const checkedCaregivers =
    caregivers.filter(caregiver => {
      const idObj = caregiver.find(item => item.key === 'id')
      return idObj && filteredItems.map(item => item.key).includes(idObj.value)
    }) || {}

  const mapCaregivers = list =>
    list
      .filter(caregiver => ptpSiteID === getSiteIdValue(caregiver))
      .map(caregiver => {
        const getValue = key => caregiver.find(item => item.key === key)?.value || ''

        const id = getValue('id')
        const subjectId = getValue('subjectId')
        return {
          key: id,
          text: subjectId,
        }
      })

  return (
    <Container>
      <div className='caregiver-assignment-section'>
        <h4>Caregiver Management</h4>
        <AutocompleteSearch
          id='search-caregivers'
          checked={mapCaregivers(checkedCaregivers)}
          toggleItem={toggleCaregiver}
          placeholder='Search for caregivers to assign with this participant'
          list={mapCaregivers(caregivers) || []}
        />
        <p className='assignment-info'>Assigned Caregivers to Participant {selectedParticipantSubjectId}</p>
        <CaregiversTable
          {...props}
          caregiverDataFields={props.caregiverDataFields}
          toggleCaregiver={toggleCaregiver}
          checkedCaregivers={Object.fromEntries(filteredItems.map(item => [item.key, true]))}
          toggleCheckAll={toggleUnCheckAll}
          caregiversList={checkedCaregivers}
          hasOverFlow
          disableRowClick
          showCheckbox
          showRelationToParticipant
          updateCaregiverRelation={updateCaregiverRelation}
        />
      </div>
    </Container>
  )
}

export default CaregiverAssignmentList
